@if (list(); as backups) {
  @if (backups.length === 0) {
    <p class="no-results">
      No results found
    </p>
  } @else {
    <div class="list-container">
      @for (b of backups; track b.id; let i = $index) {
        <div class="list-number">{{ i + 1 }}</div>
        <app-backup [id]="b.id"
                    [size]="b.size"
                    [origin]="origin()" />
      }
    </div>
  }
} @else {
  <app-loading />
}
